export default __webpack_public_path__ + "static/mini-verso-2-ae4cf115558682df9c9e136275eb0af7.jpg";